import React, { useState, useEffect } from "react";
import { Link as RouterLink } from "react-router-dom";
import { supabase } from "../supabaseClient";
import { IoLogOut } from "react-icons/io5";

function Navbar() {
  const [open, setOpen] = useState(false);
  const [user, setUser] = useState(null);

  const toggle = () => setOpen(o => !o);
  const close = () => setOpen(false);

  useEffect(() => {
    const loadUser = async () => {
      const { data } = await supabase.auth.getUser();
      setUser(data?.user || null);
    };
    loadUser();

    const { data: listener } = supabase.auth.onAuthStateChange(
      (_event, session) => setUser(session?.user || null)
    );

    return () => listener.subscription.unsubscribe();
  }, []);

  const handleLogout = async () => {
    await supabase.auth.signOut();
    setUser(null);
    close();
    window.location.href = "/";
  };

  const initials = user?.user_metadata?.full_name
    ? user.user_metadata.full_name
        .split(" ")
        .map(n => n[0])
        .join("")
        .toUpperCase()
    : user?.email
    ? user.email[0].toUpperCase()
    : "N/A";

  return (
    <nav className="fixed top-0 left-0 w-full z-50 bg-white border-b border-border">
      <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">

        {/* Logo */}
        <RouterLink
          to="/"
          onClick={close}
          className="flex items-center gap-3 text-2xl font-bold z-50 text-text-primary"
        >
          <img src="/logo.png" alt="Vector Migration Logo" className="w-8 h-8 object-contain" />
          MING
        </RouterLink>

        {/* Desktop Menu */}
        <ul className="hidden md:flex items-center gap-10 text-base font-medium text-text-primary">
          <li><RouterLink to="/" onClick={close} className="hover:text-accent transition">Home</RouterLink></li>

          {user && (
            <li><RouterLink to="/migrate" onClick={close} className="hover:text-accent transition">Migrate</RouterLink></li>
          )}

          <li><RouterLink to="/migration-insights" onClick={close} className="hover:text-accent transition">Docs</RouterLink></li>
          <li><RouterLink to="/faq" onClick={close} className="hover:text-accent transition">FAQ</RouterLink></li>
        </ul>

        {/* Desktop CTA */}
        <div className="hidden md:flex items-center gap-4">

          <a
            href="https://calendly.com/syed-agileforce/discovery-call"
            target="_blank"
            rel="noopener noreferrer"
            className="px-4 py-2 rounded-md font-semibold transition border border-primary text-primary bg-transparent hover:bg-primary hover:text-white"
          >
            Request Demo
          </a>

          {user && (
            <div className="flex items-center gap-4">
              <div
                className="w-10 h-10 rounded-full flex items-center justify-center font-semibold bg-bg-soft text-text-primary"
                title={user.email}
              >
                {initials}
              </div>

              <button
                onClick={handleLogout}
                className="p-2 rounded-md transition text-text-primary hover:bg-primary hover:text-white"
              >
                <IoLogOut size={22} />
              </button>
            </div>
          )}
        </div>

        {/* Mobile Toggle */}
        <button className="md:hidden p-2 z-50 text-2xl text-text-primary" onClick={toggle}>
          {open ? "✖" : "☰"}
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden fixed inset-0 bg-white transform transition-transform duration-300 ${
          open ? "translate-x-0" : "translate-x-full"
        }`}
        style={{ top: "73px" }}
      >
        <div className="flex flex-col h-full px-6 py-8">

          {user && (
            <div className="flex items-center justify-between pb-6 mb-6 border-b border-border">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full flex items-center justify-center font-semibold text-lg bg-bg-soft text-text-primary">
                  {initials}
                </div>
                <div>
                  <div className="font-semibold text-text-primary">{user.user_metadata?.full_name || "User"}</div>
                  <div className="text-sm text-text-muted">{user.email}</div>
                </div>
              </div>

              <button onClick={handleLogout} className="p-2 rounded-md text-text-primary hover:bg-primary hover:text-white transition">
                <IoLogOut size={22} />
              </button>
            </div>
          )}

          <ul className="flex flex-col gap-6 text-lg font-medium text-text-primary">
            <li><RouterLink to="/" onClick={close} className="hover:text-accent transition">Home</RouterLink></li>
            {user && <li><RouterLink to="/migrate" onClick={close} className="hover:text-accent transition">Migrate</RouterLink></li>}
            <li><RouterLink to="/migration-insights" onClick={close} className="hover:text-accent transition">Docs</RouterLink></li>
            <li><RouterLink to="/faq" onClick={close} className="hover:text-accent transition">FAQ</RouterLink></li>
          </ul>

          <div className="mt-auto">
            <a
              href="https://calendly.com/syed-agileforce/discovery-call"
              target="_blank"
              rel="noopener noreferrer"
              onClick={close}
              className="block text-center px-6 py-3 rounded-md font-semibold border border-primary text-primary hover:bg-primary hover:text-white transition"
            >
              Request Demo
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;